import * as MC from "./pageCodes";

// Icons are frontend-only — the backend never sends or stores icon names.
// Key = moduleCode (stable string). Value = key into Sidebar's ICON_MAP.
// Change an icon here and it updates everywhere instantly.
export const MODULE_ICON_MAP = {
  [MC.MOD_APP]:                  "dashboard",
  [MC.MOD_CATALOGUE]:            "shop",
  [MC.MOD_FULFILL]:              "truck",
  [MC.MOD_FINANCE]:              "dollar",
  [MC.MOD_REPORTS]:              "bar_chart",
  [MC.MOD_USERS]:                "team",
  [MC.MOD_SETTINGS]:             "settings",
  [MC.MOD_ACCT]:                 "person",
  [MC.MOD_MOD_PERS]:             "apartment",
  [MC.MOD_USR_ACCESS]:           "team",
  [MC.MOD_MASTER]:               "database",
  [MC.MOD_ACCT_CLIENT]:          "person",
  [MC.MOD_SUBS_CLIENT]:          "appstore",
  [MC.MOD_USR_PROFILE]:          "team",
  [MC.MOD_MANAGE_ACCESS_CLIENT]: "lock",
  [MC.MOD_PLT_CLIENTS]:          "team",
  [MC.MOD_PLT_MASTER]:           "database",
  [MC.MOD_PLT_ACCESS]:           "audit",
  [MC.MOD_CV_ACCT]:              "person",
  [MC.MOD_CV_SUBS]:              "appstore",
  [MC.MOD_CV_ACCESS]:            "audit",
};

export const DEFAULT_MODULE_ICON = "appstore";
